import IStandardOrder from "@/module/main/dto/IStandardOrder";
import OrderItem from "@/module/main/dto/financing-v3/OrderItem";

export default class StandardOrder implements IStandardOrder
{
    public readonly items: [OrderItem];

    constructor(props: IStandardOrder)
    {
        this.items = props.items;
    }
}
